import {useLinkTo} from '@react-navigation/native';
import React, {useEffect} from 'react';
import {Dimensions, StyleSheet, View} from 'react-native';
import Loading from '../components/Loading';
import {getAccessToken} from '../database/DataBase';

const WIDTH = Dimensions.get('window').width;
const HEIGHT = Dimensions.get('screen').height;

export default function SplashScreen(props) {
  const linkTo = useLinkTo();

  useEffect(() => {
    let timeout;
    getAccessToken()
      .then((data) => {
        timeout = setTimeout(() => {
          if (data != null) {
            // this.props.navigation.replace('Home'); //Home
            linkTo('/customers/home');
          } else {
            //  this.props.navigation.replace('Login'); //LOgin
            linkTo('/customers/login');
          }
        }, 4000);
      })
      .catch((e) => {
        console.log('error', e);
      });

    return () => {
      clearTimeout(timeout);
    };
  }, [linkTo]);

  return (
    <View style={styles.viewStyle}>
      <Loading />
    </View>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT,
    width: WIDTH,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'black',
  },
});
